<template>
  <div>
    <!-- Random Segment Manager Modal -->
    <b-modal id="biasedfeatureTableModal" size="xl" content-class="menu-bg-blue-transparent-modal biased-ft-modal"
      body-class="scroll-Container" title="Biased Feature Table" hide-footer scrollable
      @show="loadTable()" @hidden="displayUntestedRegions = false">
      <!-- Status Counts -->
      <b-row>
        <b-col v-if="untestedRegions.length > 0" align-self="center" cols="1" id="untestedRegions">
          <b-button @click="displayUntestedRegions = !displayUntestedRegions"
            :variant="displayUntestedRegions ? 'primary' : 'secondary'" :title="(displayUntestedRegions ? 'Hide' : 'Show') + ' Untested Regions'
              " size="lg">
            <fa :icon="['fas', 'globe-americas']" size="lg" />
          </b-button>
        </b-col>
        <b-col v-for="(element, i) in statusCounts" :key="i" class="px-1">
          <div class="ft-status-card">
            <span class="ft-status-count">{{ element.count }}</span>
            <!--Added v-if="element.Overall" - tested locally, looks fine-->
            <span v-if="element.overall" class="ft-status-label capitalize">{{ element.overall == 'not_validated' ? 'Not Validated' :
              element.overall == 'not_reviewed' ? 'Not Reviewed' : element.overall }}</span>
            <!--Changed from not_reviewed - tested locally, looks fine-->
            <!--Changed from element.Overall == 0 to !element.Overall - tested locally, looks fine-->
            <span v-else class="ft-status-label">Not Reviewed</span>
          </div>
        </b-col>
      </b-row>
      <!-- Untested Regions Display -->
      <div v-if="displayUntestedRegions" class="pb-3">
        <b-row>
          <b-col>
            <h3>Untested Regions:</h3>
          </b-col>
        </b-row>
        <div style="column-count: 5">
          <b-row v-for="(element, index) in untestedRegions" :key="index">
            <b-col>
              <ul class="ul-less-margin">
                <li>{{ element }}</li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </div>
      <b-row class="mx-2 my-1">
        <b-col class="col-md-3">
          <label>Layer Types</label>
          <b-form-select v-model="biasedLayerOption" class="propStyle" @change="refreshTable()">
            <b-form-select-option v-for="(type, index) in biasedLayerList" :key="index" :value="type.value">
              {{ type.label }}
            </b-form-select-option>
          </b-form-select>
        </b-col>
      </b-row>
      <MMP_QueryConstructor 
        class="show-desktop px-4" 
        comp="Biased" 
        :fromdate="null" 
        :todate="null" 
        :isAdmin="isAdmin"
        :user="user" 
        :getPropsApiUrl="getPropsApiUrl" 
        :getFilterApiUrl="getFilterApiUrl" 
        :getConditions="getConditions"
        :reOpened="reOpened" 
        :tableName="biasedLayerOption" 
        :selset="ansiSelectedSelset"
        :currentANSIPartNumber="currentANSIPartNumber"
        :apiUrl="apiUrl"
        @applyCustomQuery="applyCustomQuery($event)"></MMP_QueryConstructor>
      <!-- ANSI Feature Table -->
      <vue-bootstrap4-table v-show="dataLoaded" :rows="rows" :columns="columns" :config="config" :classes="classes"
        @on-select-row="zoomToFeature($event)"></vue-bootstrap4-table>
    </b-modal>
  </div>
</template>

<style>
/* ── Modal header (dark blue strip at top) ─────────────── */
.biased-ft-modal .modal-header {
  background: #063c6d;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding: 12px 20px;
  border-radius: 7px 7px 0 0;
}

.biased-ft-modal .modal-title {
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #fff;
  text-shadow: none;
}

/* ── Scrollbar ─────────────────────────────────────────── */
.biased-ft-modal .scroll-Container {
  scrollbar-width: thin;
  scrollbar-color: rgba(6, 60, 109, 0.25) transparent;
}
.biased-ft-modal .scroll-Container::-webkit-scrollbar { width: 4px; }
.biased-ft-modal .scroll-Container::-webkit-scrollbar-track { background: transparent; }
.biased-ft-modal .scroll-Container::-webkit-scrollbar-thumb { background: rgba(6, 60, 109, 0.25); border-radius: 2px; }
.biased-ft-modal .scroll-Container::-webkit-scrollbar-button { display: none; }

/* ── Status count cards ────────────────────────────────── */
.ft-status-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 10px 6px;
  background: rgba(6, 60, 109, 0.06);
  border: 1px solid rgba(6, 60, 109, 0.15);
  border-radius: 6px;
  text-align: center;
  margin-bottom: 8px;
}
.ft-status-count {
  font-size: 1.4rem;
  font-weight: 700;
  color: #063c6d;
  line-height: 1;
}
.ft-status-label {
  font-size: 0.6rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(6, 60, 109, 0.55);
}

/* ── Untested regions ──────────────────────────────────── */
.ul-less-margin {
  margin-bottom: 0.5rem;
}
.biased-ft-modal h3 {
  color: #063c6d;
  font-size: 0.9rem;
  font-weight: 700;
  text-shadow: none;
}
.biased-ft-modal .ul-less-margin li {
  color: rgba(6, 60, 109, 0.8);
  font-size: 0.75rem;
}
.untested-region-row {
  background: rgba(220, 53, 69, 0.08) !important;
}

/* ── Toggle button (show/hide untested) ────────────────── */
.biased-ft-modal .btn-primary {
  background: #063c6d !important;
  border-color: #063c6d !important;
  color: #fff !important;
}
.biased-ft-modal .btn-secondary {
  background: transparent !important;
  border-color: rgba(6, 60, 109, 0.3) !important;
  color: rgba(6, 60, 109, 0.65) !important;
}
.biased-ft-modal .btn-secondary:hover {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
}

/* ── Form controls ─────────────────────────────────────── */
.biased-ft-modal label {
  color: rgba(6, 60, 109, 0.65);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.biased-ft-modal select,
.biased-ft-modal .propStyle {
  background: #fff !important;
  border: 1px solid rgba(6, 60, 109, 0.25) !important;
  color: #063c6d !important;
  border-radius: 4px;
}
.biased-ft-modal select option {
  background: #fff;
  color: #063c6d;
}
.biased-ft-modal input[type="text"],
.biased-ft-modal input[type="search"] {
  background: #fff !important;
  border: 1px solid rgba(6, 60, 109, 0.25) !important;
  color: #063c6d !important;
  border-radius: 4px;
}
.biased-ft-modal input::placeholder {
  color: rgba(6, 60, 109, 0.35) !important;
}

/* ── Table ─────────────────────────────────────────────── */
.biased-ft-modal table {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}
.biased-ft-modal thead th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  text-shadow: none !important;
}
.biased-ft-modal thead th a,
.biased-ft-modal thead th svg {
  color: rgba(6, 60, 109, 0.5) !important;
}
.biased-ft-modal tbody tr {
  cursor: pointer;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.08) !important;
  text-shadow: none !important;
}
.biased-ft-modal tbody tr:hover {
  background: rgba(6, 60, 109, 0.04) !important;
}
.biased-ft-modal tbody td {
  border-color: rgba(6, 60, 109, 0.08) !important;
  color: #063c6d !important;
  font-size: 0.75rem;
  text-shadow: none !important;
}

/* ── Loading spinner ───────────────────────────────────── */
.biased-ft-modal .highlightLoader {
  color: rgba(6, 60, 109, 0.7) !important;
}
</style>

<script>
import VueBootstrap4Table from 'vue-bootstrap4-table'
import MMP_QueryConstructor from '../shared/MMP_QueryConstructor.vue'
import { transform } from 'ol/proj'
import axios from 'axios'
export default {
  name: 'MMP_Biased_FeatureTable',
  components: {
    VueBootstrap4Table,
    MMP_QueryConstructor
  },
  props: [
    'apiUrl',
    'ansiSelectedSelset',
    'currentANSIPartNumber',
    'hdLayerSelected',
    'isAdmin',
    'layerDefinition',
    'map',
    'user',
    'customerProjectId'
  ],
  data() {
    return {
      columns: [
        {
          column_text_alignment: 'text-left',
          label: 'SEGMENT ID',
          name: 'ansi_id',
          row_text_alignment: 'text-left',
          uniqueId: true
        },
        {
          column_text_alignment: 'text-left',
          label: 'Region',
          name: 'region',
          row_text_alignment: 'text-left',
          sort: true,
          initial_sort: true
        },
        {
          column_text_alignment: 'text-left',
          label: 'Technician',
          name: 'technician',
          row_text_alignment: 'text-left'
        },
        {
          column_text_alignment: 'text-left',
          label: 'Notes',
          name: 'notes',
          row_text_alignment: 'text-left'
        },
        {
          column_text_alignment: 'text-left',
          label: 'Status',
          name: 'status',
          row_text_alignment: 'text-left'
        }
      ],
      config: {
        card_mode: false,
        global_search: {
          placeholder: 'Search...',
          // Wait 250ms post-keyup to begin search.
          // 60ms is default, but too low of a value can cause lag.
          searchDebounceRate: 250
        },
        highlight_row_hover_color: '#4a4a4a',
        pagination: false,
        rows_selectable: true,
        show_refresh_button: false,
        show_reset_button: false
      },
      classes: {
        row: {
          'untested-region-row': row => {
            return this.untestedRegions.includes(row.region)
          }
        },
        table: {
          'menu-bg-blue-transparent': true
        }
      },
      rows: [],
      selsetData: [],
      statusCounts: null,
      dataLoaded: false,
      untestedRegions: [],
      displayUntestedRegions: false,
      getPropsApiUrl: null,
      getFilterApiUrl: null,
      getConditions: null,
      // biasedLayerList: ['lane_type_added','lane_type_diverging','lane_type_end','lane_type_ending','lane_type_merging','lane_type_start'],
      biasedLayerList: null,
      biasedLayerOption: null,
      customReportUrl: null,
      customFeatureTableUrl: null,
      customPropsUrl: null,
      customTableUrl: null,
      prevType: null,
      reOpened: false,
      prevSelset: null,
      feedback: null
    }
  },
  methods: {
    getRows() {
      this.rows = []
      this.untestedRegions = []
      let testedRegions = []
      for (let index in this.selsetData) {
        let data = this.selsetData[index]
        if (!testedRegions.includes(data.region)) {
          let untested = this.untestedRegions.indexOf(data.region)
          if (untested == -1) {
            // Region is untested
            if (data.overall) {
              // Record has value
              testedRegions.push(data.region)
            } else {
              // Record has no value
              this.untestedRegions.push(data.region)
            }
          } else if (data.overall) {
            // Region is tested and record has value
            testedRegions.push(this.untestedRegions[untested])
            this.untestedRegions.splice(untested, 1)
          }
        }
        this.rows.push({
          id: data.road_segment_id,
          region: data.region,
          technician: data.technician,
          notes: data.notes,
          status: data.overall,
          x: data.x,
          y: data.y,
          partNumber: data.partNumber,
          selset: data.selset,
          ansi_id: data.ansi_id
        })
      }
      // Alphabetizes array
      this.untestedRegions.sort()
    },
    getCountsBySelset() {
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION + `/api/${this.apiUrl}/biasedReport`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: {
                selset: this.ansiSelectedSelset,
                partNumber: this.currentANSIPartNumber.part_number,
                tableName: this.biasedLayerOption
              }
            }
          )
          .then(response => {
            const content = response.data
            if (content.errors) {
              this.feedback = content.errors[0].msg
            } else {
              this.feedback = null
              this.statusCounts = content
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.$router.push({ name: 'Login' })
      }
    },
    refreshTable() {
      this.getTableBySelset()
      this.getCountsBySelset()
    },
    async getTableBySelset() {
      this.dataLoaded = false
      if (sessionStorage.token) {
        let retVal = await axios
          .get(
            process.env.API_LOCATION + `/api/${this.apiUrl}/biasedTable`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: {
                selset: this.ansiSelectedSelset,
                partNumber: this.currentANSIPartNumber.part_number,
                tableName: this.biasedLayerOption
              }
            }
          )
          .then(response => {
            const content = response.data
            if (content.errors) {
              this.feedback = content.errors[0].msg
            } else {
              this.feedback = null
              this.selsetData = null
              this.selsetData = content
              this.getRows()
              this.dataLoaded = true
              return this.selsetData
            }
          })
          .catch(function (error) {
            console.log(error)
          })
        return retVal
      } else {
        this.$router.push({ name: 'Login' })
      }
    },
    zoomToFeature(row) {
      let x = row.selected_item.x
      let y = row.selected_item.y
      if (x != null && y != null) {
        var coord = new transform([x, y], 'EPSG:4326', 'EPSG:3857')
        this.map.getView().setCenter(coord)
        this.map.getView().setZoom(19.5)
      }
      this.$emit('toggleLidarPanel')
      this.$bvModal.hide('biasedfeatureTableModal')
      this.$parent.$refs.ansiNav.setAnsiSegmentsHistory(this.selsetData, row)
    },
    async loadTable() {
      if (
        this.rows.length == 0 ||
        this.prevType != this.layerDefinition ||
        this.prevSelset != this.ansiSelectedSelset
      ) {
        this.prevType = this.layerDefinition
        this.selsetData = null
        this.statusCounts = null
        this.prevSelset = this.ansiSelectedSelset
        this.rows = []
        this.reOpened = false
        await this.getTableBySelset()
      } else {
        await this.getTableBySelset()
        this.reOpened = true
      }
      await this.getCountsBySelset()
      this.dataLoaded = true
      this.reOpened = false
    },
    applyCustomQuery(queryRows) {
      this.rows = queryRows.rows
      this.getConditions = queryRows.cond
    },
  },
  watch: {
    getPropsApiUrl: function (newValue, oldValue) {
      this.getPropsApiUrl = newValue
    },
    layerDefinition: function (newValue, oldValue) {
      this.layerDefinition = newValue
    },
    customerProjectId: function(newValue) {
      switch(newValue) {
        case '29':
        case '5':
        case '22':
          // customerProjectId = 5 -- Nissan ANSI
          // customerProjectId = 22 -- GM ANSI
          this.biasedLayerList = [
            { value: 'lane_type_start', label: 'Start of Map' },
            { value: 'lane_type_end', label: 'End of Map' },
          ]
          this.biasedLayerOption = 'lane_type_start'
          break;
        case '23':
          // customerProjectId = 23 -- Subaru ANSI
          this.biasedLayerList = [
            { value: 'lane_type_added', label: 'Added' },
            { value: 'lane_type_diverging', label: 'Diverging' },
            { value: 'lane_type_end', label: 'End of Map' },
            { value: 'lane_type_ending', label: 'Ending' },
            { value: 'lane_type_merging', label: 'Merging' },
            { value: 'lane_type_start', label: 'Start of Map' }
          ]
          this.biasedLayerOption = 'lane_type_added'
          break;
      }
    }
  }
}
</script>
